import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Agenda\FetchAgendaEventsController::__invoke
* @see app/Http/Controllers/Agenda/FetchAgendaEventsController.php
* @route '/api/agenda/fetch-events'
*/
const FetchAgendaEventsController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: FetchAgendaEventsController.url(options),
    method: 'post',
})

FetchAgendaEventsController.definition = {
    methods: ["post"],
    url: '/api/agenda/fetch-events',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Agenda\FetchAgendaEventsController::__invoke
* @see app/Http/Controllers/Agenda/FetchAgendaEventsController.php
* @route '/api/agenda/fetch-events'
*/
FetchAgendaEventsController.url = (options?: RouteQueryOptions) => {
    return FetchAgendaEventsController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Agenda\FetchAgendaEventsController::__invoke
* @see app/Http/Controllers/Agenda/FetchAgendaEventsController.php
* @route '/api/agenda/fetch-events'
*/
FetchAgendaEventsController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: FetchAgendaEventsController.url(options),
    method: 'post',
})

export default FetchAgendaEventsController